import { useMutation, useQueryClient } from 'react-query';
import { LimitedSchemaMutationOptions } from '@frontend/react-query-helpers';
import { endpointKeys as queryEndpointKeys } from '../../queries';
import { SchemaDigitalForms } from '../../service';
import { IO } from '../../types';
import { endpointKeys } from '../keys';

/**
 * @deprecated use useUpdateReviewRequiredFlagForPacketV2 instead
 */
export const useUpdateReviewRequiredFlagForPacket = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.UpdateReviewRequiredFlagForPacket, E, C>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: endpointKeys.updateReviewRequiredFlagForPacket,
    mutationFn: (req) => SchemaDigitalForms.UpdatePacketReviewRequiredFlag(req),
    ...options,
    onSuccess: async (...successArgs) => {
      await queryClient.invalidateQueries(queryEndpointKeys.packetDetails);

      if (options?.onSuccess) {
        options.onSuccess(...successArgs);
      }
    },
  });
};

export const useUpdateReviewRequiredFlagForPacketV2 = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.UpdatePacketReviewRequiredFlagV2, E, C>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: endpointKeys.updateReviewRequiredFlagForPacketV2,
    mutationFn: (req) => SchemaDigitalForms.UpdatePacketReviewRequiredFlagV2(req),
    ...options,
    onSuccess: async (...successArgs) => {
      await queryClient.invalidateQueries(queryEndpointKeys.packetDetails);

      if (options?.onSuccess) {
        options.onSuccess(...successArgs);
      }
    },
  });
};

export const useCreatePacketV2 = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.CreatePacketV2, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.createPacketV2,
    mutationFn: (req) => SchemaDigitalForms.CreatePacketV2(req),
    ...options,
  });
};

export const useUpdatePacketV2 = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.UpdatePacketV2, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.updatePacketV2,
    mutationFn: (req) => SchemaDigitalForms.UpdatePacketV2(req),
    ...options,
  });
};

export const useDeletePacketV2 = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.DeletePacketV2, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.deletePacketV2,
    mutationFn: (req) => SchemaDigitalForms.DeletePacketV2(req),
    ...options,
  });
};

export const useUpdatePacketLocationAccess = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.UpdatePacketLocationAccess, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.updatePacketLocationAccess,
    mutationFn: (req) => SchemaDigitalForms.UpdatePacketLocationAccess(req),
    ...options,
  });
};
